import { ChatsTypes } from '../constants/chatConstants';

const initialState = {
    messages: [],
    typing: [],
};

const appendMessage = (state, message) => {
    const result = [...state.messages];
    const lastMessage = state.messages.length > 0 ? state.messages[state.messages.length - 1] : null;
    const validDelay = (new Date()).getTime() - 60000;

    const isSomeSender = lastMessage !== null && lastMessage.timestamp > validDelay && lastMessage.userId === message.userId && lastMessage.userId;

    const time = new Date();
    const messageToSave = {id:time.getTime() + String(parseInt(Math.random()*89999)+10000), ...message.message}

    if (isSomeSender) {
        result[result.length - 1].time = `${('0'+time.getHours()).substr(-2)}:${('0'+time.getMinutes()).substr(-2)}`;
        result[result.length - 1].timestamp = time.getTime();
        result[result.length - 1].messages.push(messageToSave);
    } else {
        result.push({
            userId: message.userId ,
            initial: message.initial ,
            name: message.name ,
            color: message.color,
            time: `${('0'+time.getHours()).substr(-2)}:${('0'+time.getMinutes()).substr(-2)}`,
            timestamp: time.getTime(),
            messages: [messageToSave]
        });
    }

    return result;
}

export const chatReducer = (state = initialState, action) => {
    switch (action.type) {
        case ChatsTypes.CHAT_NEW_MESSAGE:
            return {
                ...state,
                messages: appendMessage(state, action.message)
            };

        case ChatsTypes.CHAT_TYPING_MESSAGE:
            return {
                ...state,
                typing: [action.user]
            };

        case ChatsTypes.CHAT_STOPTYPING_MESSAGE:
            return {
                ...state,
                typing: state.typing.filter(i => i !== action.user)
            };

        case ChatsTypes.RESET:
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
};